export default function Index() {
  return (
    <main>
      <div>Index page has nothing to show. go to /article</div>
    </main>
  );
}
